<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headertoc01" class="chapter" epub:type="toc" id="toc" role="doc-toc">
<header id="headertoc01">
<h1 class="ctfm"><span aria-label="v" class="page" id="pv" role="doc-pagebreak"></span><span class="sm">CONTENTS</span></h1>
</header>
<p class="tocf"><a class="xref" href="#/chiBartlettSOPHISTRYpbkupdate0006#intro">Introduction</a></p>
<p class="tocpt"><a class="xref" href="#/chiBartlettSOPHISTRYpbkupdate0007#pt01"><i>Part One: On the</i> Protagoras</a></p>
<p class="toc"><a class="xref" href="#/chiBartlettSOPHISTRYpbkupdate0008#ch01">Chapter One</a></p>
<p class="toc"><a class="xref" href="#/chiBartlettSOPHISTRYpbkupdate0009#ch02">Chapter Two</a></p>
<p class="toc"><a class="xref" href="#/chiBartlettSOPHISTRYpbkupdate0010#ch03">Chapter Three</a></p>
<p class="tocpt"><a class="xref" href="#/chiBartlettSOPHISTRYpbkupdate0011#pt02"><i>Part Two: On the</i> Theaetetus <i>(142a1–183c7)</i></a></p>
<p class="toc"><a class="xref" href="#/chiBartlettSOPHISTRYpbkupdate0012#ch04">Chapter Four</a></p>
<p class="toc"><a class="xref" href="#/chiBartlettSOPHISTRYpbkupdate0013#ch05">Chapter Five</a></p>
<p class="toc"><a class="xref" href="#/chiBartlettSOPHISTRYpbkupdate0014#conc">Conclusion</a></p>
<p class="tocbmf"><a class="xref" href="#/chiBartlettSOPHISTRYpbkupdate0015#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chiBartlettSOPHISTRYpbkupdate0016#refs">References</a></p>
<p class="tocbm"><a class="xref" href="#/chiBartlettSOPHISTRYpbkupdate0017#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-Bartlett-SOPHISTRY-pbk-update-0005.vue?2490ff8e